import React, { useEffect, useState } from 'react';
import { Button, Modal, Tooltip, message } from 'antd';
import { BellOutlined, CheckCircleFilled } from '@ant-design/icons';
// iOS ana ekran kontrolü BU BİLEŞENDE DEĞİL: `abonelikKur` kendi içinde
// bakıp `sebep: 'ios_ana_ekran'` döndürüyor. Karar orada olmalı — kontrol
// burada da tekrarlansaydı iki yerin birden doğru kalması gerekirdi.
import {
  abonelikKur,
  aboneliktenCik,
  mevcutAbonelik,
  pushDesteginiKontrolEt,
  serviceWorkerKaydet,
} from '../../utils/webPush';

/**
 * "Bildirimleri Aç" — web push aboneliği.
 *
 * NEREYE KONULUYOR (22.09.2026, Eren Bey'in geri bildirimi):
 * Başlangıçta her ekranda başlıkta duruyordu ve masaüstünde kötü
 * görünüyordu. Artık iki yerde, iki farklı görünümde:
 *
 *   gorunum="link"  → bildirim menüsünün altında, "Tümünü Gör" yanında.
 *                     HER CİHAZDA. Zile basan kişi zaten bildirim ayarı
 *                     arıyordur; ayrıca masaüstünde de özelliğin
 *                     kaybolmaması gerekiyor — güvenlik uyarısı ve cron
 *                     arızası yöneticiye tarayıcı kapalıyken ancak bu
 *                     kanaldan ulaşıyor.
 *   gorunum="dugme" → başlıkta, YALNIZCA telefonda ve `aboneyseGizle`
 *                     ile birlikte. Velinin bulabilmesi için görünür bir
 *                     çağrı gerekiyor; abone olunca kayboluyor, yeşil tik
 *                     başlıkta asılı kalmıyor.
 *
 * İZİN OTOMATİK İSTENMİYOR, düğmeden isteniyor. iOS sayfa açılışında
 * kendiliğinden istenen izni reddediyor; ayrıca sormadan izin kutusu
 * açmak kötü bir karşılama.
 *
 * Düğme, işe yaramayacağı durumlarda HİÇ ÇİZİLMİYOR (tarayıcı
 * desteklemiyorsa, sunucuda VAPID tanımlı değilse ya da kişi mobil
 * uygulamayı kullanan bir roldeyse) — çalışmayan bir düğme göstermek,
 * hiç göstermemekten kötü.
 */

// Bu roller mobil uygulamayı kullanıyor ve bildirimi zaten Expo push ile
// alıyorlar; web'den de açarlarsa aynı bildirimi telefonlarında İKİ KEZ
// görürler. Şube müdürü de mobil kullanıyor (kullanıcı 22.09.2026'da
// düzeltti — ilk konuşmada "yönetici" sayılıp dışarıda bırakılmıştı).
// Süper/developer admin BİLEREK dışarıda: uygulamaya girebiliyorlar ama
// uygulama onlara çok az şey gösteriyor, asıl yüzeyleri web.
//
// ASIL KAPI SUNUCUDA (PushSubscriptionController 403 döner) — buradaki
// liste yalnızca düğmeyi gizliyor, yetki kontrolü değil.
const MOBIL_KULLANAN_ROLLER = ['teacher', 'stajyer', 'branch_manager'];

const BildirimIzniDugmesi = ({
  vapidPublicKey,
  rol,
  gorunum = 'dugme',
  aboneyseGizle = false,
}) => {
  const [destekli, setDestekli] = useState(false);
  const [abone, setAbone] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (!pushDesteginiKontrolEt() || !vapidPublicKey) return;
    if (MOBIL_KULLANAN_ROLLER.includes(rol)) return;
    setDestekli(true);

    // Kayıt burada yapılabilir (izin istemiyor, yalnızca worker'ı yüklüyor).
    serviceWorkerKaydet();
    mevcutAbonelik().then((a) => setAbone(!!a));
  }, [vapidPublicKey, rol]);

  if (!destekli) return null;
  if (abone && aboneyseGizle) return null;

  const ac = async () => {
    setYukleniyor(true);
    const sonuc = await abonelikKur(vapidPublicKey);
    setYukleniyor(false);

    if (sonuc.ok) {
      setAbone(true);
      message.success('Bildirimler açıldı. Bu cihaza bildirim gönderilecek.');
      return;
    }

    if (sonuc.sebep === 'ios_ana_ekran') {
      Modal.info({
        title: 'Önce uygulamayı ana ekrana ekleyin',
        content: (
          <div>
            <p>
              iPhone ve iPad'de bildirimler yalnızca site <b>ana ekrana eklendiğinde</b> çalışıyor.
              Bu Apple'ın kuralı, tarayıcı sekmesinde bildirim gönderilemiyor.
            </p>
            <p style={{ marginBottom: 4 }}><b>Nasıl yapılır:</b></p>
            <ol style={{ paddingLeft: 18, margin: 0 }}>
              <li>Safari'de alttaki <b>Paylaş</b> düğmesine dokunun</li>
              <li><b>Ana Ekrana Ekle</b>'yi seçin</li>
              <li>Ana ekrandaki <b>ARYS</b> simgesinden açın</li>
              <li>Buradaki <b>Bildirimleri Aç</b> düğmesine tekrar dokunun</li>
            </ol>
          </div>
        ),
        okText: 'Anladım',
      });
      return;
    }

    if (sonuc.sebep === 'izin_verilmedi') {
      message.warning(
        'Bildirim izni verilmedi. Tarayıcı ayarlarından bu site için bildirimlere izin verebilirsiniz.'
      );
      return;
    }

    message.error('Bildirimler açılamadı. Lütfen tekrar deneyin.');
  };

  const kapat = async () => {
    setYukleniyor(true);
    await aboneliktenCik();
    setYukleniyor(false);
    setAbone(false);
    message.success('Bu cihaza bildirim gönderilmeyecek.');
  };

  const link = gorunum === 'link';

  if (abone) {
    return (
      <Tooltip title="Bu cihazda bildirimler açık — kapatmak için tıklayın">
        <Button
          type={link ? 'link' : 'text'}
          size="small"
          loading={yukleniyor}
          icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}
          onClick={kapat}
        >
          Bildirimler açık
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Uygulama kapalıyken de bildirim almak için açın">
      <Button
        type={link ? 'link' : 'primary'}
        ghost={!link}
        size="small"
        loading={yukleniyor}
        icon={<BellOutlined />}
        onClick={ac}
      >
        Bildirimleri Aç
      </Button>
    </Tooltip>
  );
};

export default BildirimIzniDugmesi;
